import { connect } from 'react-redux'

import { selectItem } from '../../../../common/actions/layout'
import { fetchItemLicenses } from '../../../../common/actions/searchPage'
import ItemDetails from './itemDetails'

const mapStateToProps = (state, ownProps) => {
  const { layout: { selectedItemId }, searchPage: { licenses } } = state

  return {
    selected: selectedItemId === ownProps.item.id,
    licenses: licenses
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectItem: itemId => {
      dispatch(selectItem(itemId))
    },
    fetchItemLicenses: itemId => {
      dispatch(fetchItemLicenses(itemId))
    }
  }
}

const ItemDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(
  ItemDetails
)

export default ItemDetailsContainer
